import { Controller } from "@hotwired/stimulus"

// Keeps a collapsed settings card's one-line summary ("已開啟 2/3 項 · 夜間勿擾開啟") in step with its switches.
export default class extends Controller {
  static targets = [ "text", "kind", "quiet" ]
  static values = { countTemplate: String, quietLabel: String }

  // consent-toggle may revert a switch after a failed save; read the state once that has settled
  refresh() {
    requestAnimationFrame(() => setTimeout(() => this.render(), 0))
  }

  render() {
    const on = this.kindTargets.filter((input) => input.checked).length
    let text = this.countTemplateValue.replace("__ON__", on)
    if (this.hasQuietTarget && this.quietTarget.checked) text += ` · ${this.quietLabelValue}`
    this.textTarget.textContent = text
  }
}
